import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Hem', id: 'hem' },
    { name: 'Om', id: 'om' },
    { name: 'Filosofi', id: 'filosofi' },
    { name: 'Tjänster', id: 'tjanster' },
    { name: 'Priser', id: 'priser' },
  ];

  const handleNavClick = (e, id) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'
        }`}
      >
        <div className="container mx-auto px-6 md:px-12 flex items-center justify-between">
          <a href="/" onClick={(e) => handleNavClick(e, 'hem')} className="flex items-center">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/5c1e3a15fc68e7fca62dc4ec64936fd2c3f13f974599de31727b7a91865820cd8939af7242306cdc50be50497057948e/images/aW1hZ2UvcG5n/d6937394eb4d6a56959e8c727708d311.png" 
              alt="Starkare Logo" 
              className="h-10 w-auto object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            <ul className="flex items-center gap-8">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={(e) => handleNavClick(e, link.id)}
                    className="text-sm text-stone-600 hover:text-stone-900 transition-colors uppercase tracking-widest font-light"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
            <div className="flex items-center gap-4">
               <button 
                onClick={() => navigate('/portal')}
                className="text-sm text-stone-900 hover:text-stone-600 transition-colors uppercase tracking-widest font-medium"
               >
                 Portal
               </button>
               <a 
                 href="mailto:hej@starkaremeddiana.se?subject=Bokningsförfrågan"
                 className="px-6 py-2 bg-stone-900 text-white text-xs uppercase tracking-widest hover:bg-stone-800 transition-colors"
               >
                 Boka
               </a>
            </div>
          </nav>

          {/* Mobile Toggle */}
          <button 
            className="md:hidden text-stone-900 text-2xl"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <SafeIcon icon={isMobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} />
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed inset-0 z-40 bg-white pt-24 px-6"
          >
            <ul className="flex flex-col gap-6 text-center">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={(e) => handleNavClick(e, link.id)}
                    className="text-2xl font-serif text-stone-900"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
              <li className="mt-8 flex flex-col gap-4">
                 <button 
                  onClick={() => { setIsMobileMenuOpen(false); navigate('/portal'); }}
                  className="inline-block w-full py-4 border border-stone-900 text-stone-900 text-sm uppercase tracking-widest"
                 >
                  Portal
                 </button>
                 <a 
                  href="mailto:hej@starkaremeddiana.se?subject=Bokningsförfrågan"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="inline-block w-full py-4 bg-stone-900 text-white text-sm uppercase tracking-widest"
                >
                  Boka Nu
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;